(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["td-product-gallery--variation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-variation-gallery')) {
  class TdVariationGallery extends HTMLElement {
    constructor() {
      super();
      this.variantChangeUnsubscriber = undefined;
    }

    connectedCallback() {
      const sectionId = this.dataset.section;
      if (!sectionId) return;

      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.data.sectionId !== sectionId) return;

        const sourceGallery = event.data.html.querySelector(
          `td-variation-gallery[data-section="${sectionId}"]`
        );

        if (!sourceGallery) return;

        const galleryGrid = sourceGallery.querySelector('.td-pdp__gallery-grid');
        const destinationGrid = this.querySelector('.td-pdp__gallery-grid');

        if (galleryGrid && destinationGrid) {
          destinationGrid.innerHTML = galleryGrid.innerHTML;
        }
      });
    }

    disconnectedCallback() {
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }
  }

  customElements.define('td-variation-gallery', TdVariationGallery);
}
  } catch(e) { console.error(e); }
})();

})();
